import { ApolloClient, InMemoryCache } from '@apollo/client';
import { HttpLink } from '@apollo/client/link/http';
import { SetContextLink } from '@apollo/client/link/context';

import env from '../env';

import { refreshAccessToken, handleLogout } from '../../../hooks-react/src/useAuth';

let client: ApolloClient | null = null;
let publicClient: ApolloClient | null = null;

export const getApolloClient = () => {
  client ??= createApolloClient();
  return client;
};

export const getAuthApolloClient = () => getApolloClient();

export const getPublicApolloClient = () => {
  publicClient ??= createPublicApolloClient();
  return publicClient;
};

export const createPublicApolloClient = () => {
  const httpLink = new HttpLink({
    uri: env.APP_GRAPHQL_ENDPOINT,
  });

  return new ApolloClient({
    link: httpLink,
    cache: new InMemoryCache(),
    defaultOptions: {
      watchQuery: {
        fetchPolicy: 'cache-and-network',
      },
    },
  });
};

export const createApolloClient = () => {
  const httpLink = new HttpLink({
    uri: env.APP_GRAPHQL_ENDPOINT,
  });

  const authLink = new SetContextLink(async (_: any, { headers }: any) => {
    let token = localStorage.getItem('access_token');
    const refreshToken = localStorage.getItem('refresh_token');

    if (token && typeof window !== 'undefined') {
      try {
        const base64Url = token.split('.')[1];

        if (base64Url && refreshToken) {
          const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
          const payload = JSON.parse(window.atob(base64));
          const isExpired = Date.now() >= payload.exp * 1000;

          if (isExpired) {
            try {
              const newTokens = await refreshAccessToken(refreshToken as string);
              const newToken = newTokens?.AccessToken;
              if (newToken) {
                token = newToken;
                localStorage.setItem('access_token', newToken);
                if (newTokens.RefreshToken) {
                  localStorage.setItem('refresh_token', newTokens.RefreshToken as string);
                }

                // Role change detection
                const newPayload = JSON.parse(window.atob(newToken?.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')));
                const prevRole = (JSON.parse(payload?.custom_payload || '{}') || {})?.role;
                const currentRole = (JSON.parse(newPayload?.custom_payload || '{}') || {})?.role;
                if (prevRole && currentRole && prevRole !== currentRole) {
                  window.location.reload();
                }
              } else {
                handleLogout();
              }
            } catch (error) {
              console.error('Token refresh execution failed:', error);
              handleLogout();
            }
          }
        }
      } catch (e) {
        console.error('Token refresh failed:', e);
      }
    }

    return {
      headers: {
        ...(headers || {}),
        authorization: token ? `Bearer ${token}` : '',
      },
    };
  });

  return new ApolloClient({
    link: authLink.concat(httpLink),
    cache: new InMemoryCache(),
    defaultOptions: {
      watchQuery: {
        fetchPolicy: 'cache-and-network',
      },
    },
  });
};
